import { render, staticRenderFns } from "./TNC11000.vue?vue&type=template&id=ffefbaee&"
import script from "./TNC11000.vue?vue&type=script&lang=js&"
export * from "./TNC11000.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports